import React from 'react';
import styled from 'styled-components';
import { standardColours, zIndexLayers } from '../styles';
import { Svg } from './ui';
import loadingIcon from '../images/loading-icon.inline.svg';

const StyledLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: ${standardColours.transparentBlack(0.2)};
  z-index: ${zIndexLayers.sixth};
`;

const StyledIcon = styled(Svg)`
  height: 60px;
  width: 60px;
`;

const Loader = ({ ...props }) => (
  <StyledLoader {...props}>
    <StyledIcon image={loadingIcon} />
  </StyledLoader>
);

export default Loader;
